import React, { useEffect, useState } from 'react'

// components
import Header from '_components/header/index.jsx'
import EventFeedsWizard from '../wizard/index.jsx'
import ListView from '_components/list-view/index.jsx'

import { cloneFeed, createFeed, deleteFeed } from '_services/event-feeds'

// libraries
import sendAnalytics from '_root/lib/sendAnalytics.js'

import './styles.scss'
import { logErrorAsync } from '../../../lib/utility.js'
import BatchProcessModal from '_components/batch-process-modal/index.jsx'

// constants
const ENTITY = 'event-feeds'

const getEnum = (fieldName) => {
  return new Promise((resolve, reject) => {
    window._api.get(`/event-feeds/enum/${fieldName}`, {}, (err, resp) => {
      if (err) {
        logErrorAsync(err)
        return reject(err)
      }
      resolve(resp)
    })
  })
}

const STATUSES = [
  { label: 'Draft', value: 'draft' },
  { label: 'Submitted', value: 'submitted' },
  { label: 'Processed', value: 'processed' },
  { label: 'Updated', value: 'updated' },
  { label: 'Archived', value: 'archived' },
]
const IS_SAMPLE = [{ label: 'Yes', value: 'one-time' }]

// Feeds Page
const EventFeedsListView = () => {
  const [wizardOpen, setWizardOpen] = useState(false)
  const [creators, setCreators] = useState([])
  const [clients, setClients] = useState([])
  const [deleting, setDeleting] = useState(false)
  const [deletePercentage, setDeletePercentage] = useState(0)
  const [selecteds, setSelecteds] = useState([])
  const [cloning, setCloning] = useState(false)
  const [clonePercentage, setClonePercentage] = useState(0)

  useEffect(() => {
    async function getEnums() {
      try {
        const creatorsResponse = await getEnum('created_by.email')
        const clientsResponse = await getEnum('client.name')

        setCreators(creatorsResponse)
        setClients(clientsResponse)
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
    }
    getEnums()
  }, [])

  const handleCreateFeed = async (newFeed) => {
    try {
      const newFeedResponse = await createFeed(ENTITY, newFeed)
      setWizardOpen(false)
      sendAnalytics('create', ENTITY, newFeedResponse)
      window._history.push(`/data-explorer/${newFeedResponse._id}`)
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  const handleDelete = async () => {
    setDeleting(true)
    const oneStepPercentage = 1 / selecteds.size
    for (const id of selecteds) {
      await deleteFeed(`${ENTITY}/${id}`, { id })
      setDeletePercentage((deletePercentage) => deletePercentage + oneStepPercentage)
    }
    setDeleting(false)
  }

  const handleClone = async () => {
    setCloning(true)
    const oneStepPercentage = 1 / selecteds.size
    for (const id of selecteds) {
      await cloneFeed(`${ENTITY}/clone/${id}`, { id })
      setClonePercentage((clonePercentage) => clonePercentage + oneStepPercentage)
    }
    setCloning(false)
  }

  return (
    <div id="data-feeds-page">
      <Header
        title="Data Feeds"
        actions={[
          {
            children: 'Create New Feed',
            onClick: () => setWizardOpen(true),
          },
        ]}
      />
      <ListView
        columns={[
          {
            name: 'Feed Name',
            key: 'name',
            link: '/data-explorer/:_id',
            sortable: true,
            // width: 420,
          },
          // {
          //   name: 'Type',
          //   key: 'type',
          //   render: (item) => (item.type === 'prebuilt_attributes_v2' ? 'Predictors' : 'Default'),
          //   sortable: true,
          // },
          {
            key: 'client.name',
            link: '/companies/:client._id',
            name: 'Client',
            sortable: true,
          },
          {
            format: 'date',
            name: 'Created At',
            key: 'created_at',
            sortable: true,
          },
          {
            format: 'date',
            key: 'updated_at',
            name: 'Last Updated',
            sortable: true,
          },
          {
            key: 'created_by',
            name: 'Created by',
            sortable: true,
            render: (item) => item.created_by.email,
          },
          {
            key: 'deliveries.0.status',
            name: 'Status',
            sortable: true,
          },
          {
            key: 'deliveries.0.frequency',
            name: 'Is Sample',
            sortable: true,
            render: (item) => (item.deliveries[0]?.frequency === IS_SAMPLE[0].value ? 'Yes' : '-'),
          },
        ]}
        entities="event-feeds"
        filters={[
          {
            label: 'Client',
            name: 'client.name',
            options: clients,
            all: true,
            className: 'event-feeds-list-view__filter',
          },
          {
            label: 'Created by',
            name: 'created_by.email',
            options: creators,
            all: true,
            className: 'event-feeds-list-view__filter',
          },
          {
            label: 'Status',
            name: 'deliveries.status',
            options: STATUSES,
            all: true,
            className: 'event-feeds-list-view__filter',
          },
          {
            label: 'Is Sample',
            name: 'deliveries.frequency',
            options: IS_SAMPLE,
            all: true,
            className: 'event-feeds-list-view__filter',
          },
        ]}
        fields={[
          'client.name',
          'type',
          'client._id',
          'created_at',
          'updated_at',
          'name',
          'created_by.email',
          'deliveries',
        ]}
        searchable={true}
        sort_key={'updated_at'}
        sort_dir={-1}
        actions={[
          {
            name: 'Clone',
            onClick: handleClone,
            icon: {
              icon: 'plus',
              type: 'outline',
            },
          },
          {
            name: 'Delete',
            onClick: handleDelete,
            icon: {
              icon: 'trashcan',
              type: 'outline',
            },
          },
        ]}
        onSelectionChange={({ currentSelected }) => setSelecteds(new Set(currentSelected))}
        filter_on_load={{ type: 'default' }}
        dontStoreFilters
      />
      <EventFeedsWizard
        isOpen={wizardOpen}
        onClose={() => setWizardOpen(false)}
        onFinish={handleCreateFeed}
        onCreateWithoutWizard={handleCreateFeed}
      />
      <BatchProcessModal
        title="Deleting selected feeds..."
        subtitle="This process will be done in a few seconds"
        isOpen={deleting}
        onClose={() => {}}
        onClick={() => {}}
        percentage={deletePercentage}
      />
      <BatchProcessModal
        title="Cloning selected feeds..."
        subtitle="This process will be done in a few seconds"
        isOpen={cloning}
        onClose={() => {}}
        onClick={() => {}}
        percentage={clonePercentage}
      />
    </div>
  )
}

// export
export default EventFeedsListView
